// De APE-planningsinstellingen. Defaults en grenzen spiegelen ApePlanningDefaults.cs en
// ApeParameterLimits.cs; de grenzen zijn die van APE zelf, daarbuiten weigert APE de aanvraag met een 422.

// Rustpauzes staan standaard aan: de pauzeregeling (na 4,5 uur rijden 45 minuten pauze) is een wettelijke
// verplichting, dus een vergeten schakelaar mag geen onwettige planning opleveren.
export const DefaultApeUseRijtijdenwet = true;

export const DefaultApeSearchTimeLimitSeconds = 30;
export const DefaultApeOvertimeMinutes = 30;
export const DefaultApeWinchServiceTimeInMinutes = 10;

// 80 km/u: de Nederlandse maximumsnelheid voor een vrachtwagen. APE valt zonder deze waarde terug op 90 en
// rekent de rit dan te snel — gemeten 72 tot 80 km/u gemiddeld, tegen 33 tot 56 km/u bij PTV op dezelfde legs.
export const DefaultApeMaxSpeedKilometersPerHour = 80;

// Hoeveel trajecten er in één planrun mee mogen. Bewust lager dan de serverkant
// (ApeConfiguration.MaxTrajectories, 2000): de planner hoort tijdens het selecteren al te merken dat de
// selectie te groot wordt, in plaats van pas bij het starten. Blijft deze waarde onder de servergrens, dan
// kan een selectie die het scherm toestaat nooit alsnog bij het starten worden afgekeurd.
export const MaxPlanRunTrajectories = 500;

export const ApeSearchTimeLimitSecondsMinimum = 1;
export const ApeSearchTimeLimitSecondsMaximum = 1800;

// Het veld kent een eenheidskeuze; in minuten gelden dezelfde grenzen als hierboven, afgerond op hele minuten.
export const ApeSearchTimeLimitMinutesMinimum = 1;
export const ApeSearchTimeLimitMinutesMaximum = 30;

export const ApeOvertimeMinutesMinimum = 0;
export const ApeOvertimeMinutesMaximum = 1440;

export const ApeServiceTimeMinutesMinimum = 0;
export const ApeServiceTimeMinutesMaximum = 1440;

// De bovengrens is die van APE, niet die van het verstand: hij staat er om een 422 te voorkomen.
export const ApeMaxSpeedKilometersPerHourMinimum = 10;
export const ApeMaxSpeedKilometersPerHourMaximum = 252;
